import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=35b664bc&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=35b664bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b664bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b664bc')) {
      api.createRecord('35b664bc', component.options)
    } else {
      api.reload('35b664bc', component.options)
    }
    module.hot.accept("./NoData.vue?vue&type=template&id=35b664bc&scoped=true&", function () {
      api.rerender('35b664bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/NoData.vue"
export default component.exports